// src/pages/ChapterFive.js
// Chapter 5 — Rudolph’s Ride: Jingle Bells
// Story: Rudolph is trying to connect with Santa. Playing “Jingle Bells” helps
// broadcast a musical signal that Santa can catch — but ONLY after the melody is completed.

import React from "react";
import ChapterTemplate from "../components/ChapterTemplate";

// 🎵 Jingle Bells — per your sequence:
// EEE  EEE
// EGCDE
// FFFF  FEEE
// GGFDC

// Pretty, line-broken display (use "__" as visual spacer between phrases)
const jingleLines = [
  ["E", "E", "E", "__", "E", "E", "E"],
  ["E", "G", "C", "D", "E"],
  ["F", "F", "F", "F", "__", "F", "E", "E", "E"],
  ["G", "G", "F", "D", "C"],
];

// Flattened for the listener (Template will flatten too if only melodyLines used)
const jingleTarget = [
  "E","E","E", "E","E","E",
  "E","G","C","D","E",
  "F","F","F","F", "F","E","E","E",
  "G","G","F","D","C",
];

// 🖼️ Story slides (placeholders — swap images later, keep filenames to avoid refactors)
// NOTE: These slides avoid revealing success; Santa only “hears it” AFTER gameplay completion.
const ChapterFiveStory = [
  {
    image: "/images/ChapterFive/Chp5 Slide 1.png",
    text: "Pan and Wis reach Rudolph’s Field—signal bars: zero. Uh-oh.",
  },
  {
    image: "/images/ChapterFive/Chp5 Slide 2.png",
    // text: "Rudolph has tried calling, texting, even video—still no connection.",
  },
  {
    image: "/images/ChapterFive/Ch5 Slide 3.png",
    text: "“Music travels everywhere. Play Jingle Bells!” says Wis.",
  },
];

export default function ChapterFive() {
  return (
    <ChapterTemplate
      chapterNumber={5}
      chapterTitle="Rudolph’s Ride — Jingle Bells"
      sceneImageSrc="/images/ChapterFive/Melody Image.png"
      storySlides={ChapterFiveStory}
      songTitle="Jingle Bells"
      melodyLines={jingleLines}
      targetMelody={jingleTarget}
      companionsText={{
        wis: "Steady pulse! Let the bells ‘ring’ on each E.",
        pan: "We’ve got this—keep the rhythm and follow the notes!",
      }}
      unlockNextChapterPath="/chapter-6"
      // Doron stays asleep this chapter (no special flag needed)
    />
  );
}
